module.exports = __webpack_public_path__ + "promotion-banner-desktop-kec.bca1851e86607f56ae848b2e7f9b0727.png";